// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-component:disabled{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));--bg-opacity:1;background-color:#c2cddd;background-color:rgba(194,205,221,var(--bg-opacity));cursor:not-allowed}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
